import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { useAuth } from "../../../contexts/AuthProvider/useAuth";
import { Modal, ModalRef } from "../../../components/Modal";
import { toastError } from "../../../commons/utils";
import { model_colaborador_classificacao } from "../../../models";
import { ExSelect } from "../../../components/ExSelect";
import { UserStar } from "lucide-react";
import { ExControls } from "../../../components/ExControls";

export interface ColaboradorClassificacaoRef {
    openModal: (colid: string, colclassid?: string) => void;
    closeModal: () => void;
}

export interface ColaboradorClassificacaoProps {
    onSuccess?: () => void;
}

export const ColaboradorSelecionaClassificacao = forwardRef<ColaboradorClassificacaoRef, ColaboradorClassificacaoProps>(({ onSuccess }, ref) => {
    const auth = useAuth();

    const [colclassid, setColclassid] = useState<any>();
    const [colid, setColid] = useState<string>()

    const refmodal = useRef<ModalRef>(null);
    const refinputclass = useRef<any>(null);
    const refObservacao = useRef<any>(null);

    // async function getProdutos(id: string) {
    //     setProdUnidId(id);

    //     await auth.get('/v1/produtounidademedidaprodutocrm?produnidid=' + id)
    //         .then((response: any) => {
    //             const _produtos = response.data.map((item: any) => ({
    //                 value: item.prodid,
    //                 label: item.proddescricao
    //             }));

    //             setProdutos(_produtos);
    //             refinputclass.current.setValue(_produtos);
    //         })
    //         .catch((error: any) => toastError(error));
    // }

    function openModal(colid: string, colclassid?: string) {
        setColid(colid)
        setColclassid(colclassid || null)
        refmodal.current?.openModal();
    }

    function closeModal() {
        refmodal.current?.closeModal();
    }

    useImperativeHandle(ref, () => ({
        openModal,
        closeModal
    }));

    async function handleSuccess() {
        const refValue = refinputclass.current.getValue();
        const colclasshistobservacao = refObservacao.current.getValue()

        let body = {
            colclassid: refValue,
            colclasshistobservacao
        };

        await auth.post('/v1/colaboradorclassificacaocrm', body, { colid })
            .then(() => {
                refmodal.current?.closeModal();
                onSuccess?.();
            })
            .catch((error: any) => toastError(error));
    }

    return (
        <Modal
            ref={refmodal}
            title="Classificação de Colaborador"
            icon={<UserStar style={{ fontSize: '24px' }} />}
            size="md"
            success={() => handleSuccess()}
        >
            <ExSelect ref={refinputclass} id="colclassid" label="Classificação" model={model_colaborador_classificacao} defaultValue={colclassid} />
            <ExControls ref={refObservacao} id={'colclasshistobservacao'} type={'text'} label={'Observação'} />
        </Modal>
    );
}
);
